<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/three.jpg" /></div>
      <p>Three</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/three/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/three.js", ur + "1.0.0/three.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListThree.vue